import React from 'react';

interface ProductCatalogProps {
  children?: React.ReactNode;
}

export default function ProductCatalog({ children }: ProductCatalogProps) {
  // Дефолтный контент, если нет children
  const defaultContent = (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
      <div className="product-card p-4 border rounded-lg">
        <h4 className="font-semibold">Листовий прокат</h4>
        <p className="text-sm text-gray-600 mt-2">Гарячекатаний, холоднокатаний, оцинкований</p>
        <a href="/catalog/listy" className="text-blue-600 text-sm mt-3 inline-block">Детальніше</a>
      </div>
      <div className="product-card p-4 border rounded-lg">
        <h4 className="font-semibold">Сортовий прокат</h4>
        <p className="text-sm text-gray-600 mt-2">Арматура, кутик, швелер, двутавр</p>
        <a href="/catalog/sort" className="text-blue-600 text-sm mt-3 inline-block">Детальніше</a>
      </div>
      <div className="product-card p-4 border rounded-lg">
        <h4 className="font-semibold">Трубний прокат</h4>
        <p className="text-sm text-gray-600 mt-2">Круглі, профільні, водогазопровідні</p>
        <a href="/catalog/truby" className="text-blue-600 text-sm mt-3 inline-block">Детальніше</a>
      </div>
    </div>
  );

  return (
    <div className="my-8 p-6 bg-gray-50 rounded-lg">
      <h3 className="text-2xl font-bold mb-4">Каталог металлопроката</h3>
      {children || defaultContent}
    </div>
  );
} 